<template>
    <div class="authenticeface">
        <div class="authenticeface-operate">请您打开手机，使用百度APP扫描下方二维码，完成活体(人脸)认证， </div>
        <div class="authenticeface-info">真实姓名：{{ userInfo.pass_info && userInfo.pass_info.pass_name }}</div>
        <div class="authenticeface-info">身份证号：{{ userInfo.pass_info && userInfo.pass_info.cert_code }}</div>
        <div class="authenticeface-qrcode">
            <div id="IDCertifyQrcode"></div>
            <div class="authenticeface-notify">
                <img class="authenticefacescan" src="../../../assets/img/law/scan.png" alt="">
                <div>打开手机百度，点击相机</div>
            </div>
        </div>
        <!-- <veui-form  ref="form" :data="formData">
            <veui-field name="checked" field="checked"  class="agree"
                 :rules="[{
                    name: 'required',
                    value: true,
                    message: '请勾选阅读协议',
                    triggers: 'change'
                }]">
                <veui-checkbox
                    :false-value="null"
                    v-model="formData.checked"
                >
                    我已阅读并同意: <span class="rule">《百度个人实名认证规则说明》</span>
                </veui-checkbox>
            </veui-field>
        </veui-form> -->
    </div>
</template>

<script>

export default {
    name: 'authentice-face',
    components: {
    },
    props: {
        userInfo: {
            'type': Object,
            'default': {}
        }
    },
    data() {
        return {
            formData: {
                checked: null
            }
        };
    },
    mounted() {
        this.$nextTick(function () {
            let that = this;
            window.passport.use('IDCertifyQrcode', {
                tangram: true
            }, function (magic) {
                if (magic && magic.passport && magic.passport.IDCertifyQrcode) {
                    let IDCertifyQrcode = new magic.passport.IDCertifyQrcode({
                        product: 'lvlin',
                        u: window.location.protocol + '//passport.baidu.com/passApi/html/success.html',
                        safeFlag: 0,
                        defaultCss: true,
                        animation: (/[?&]animation=([^&]*)/.exec(location.href) && /[?&]animation=([^&]*)/.exec(location.href)[1])
                            ? /[?&]animation=([^&]*)/.exec(location.href)[1] : '',
                        staticPage: window.location.protocol + '//passport.baidu.com/passApi/html/jump.html'
                    });
                    // 'IDCertifyQrcodeSuccess'
                    IDCertifyQrcode.on('IDCertifyQrcodeSuccess', function (e) {
                        that.$emit('changeCurrentIndex', 3);
                        that.$emit('update:firmLawyerCurrent', 3);
                        that.$emit('update:current', 3);
                        that.$emit('getData');
                        e.returnValue = false;
                    });
                    IDCertifyQrcode.render('IDCertifyQrcode');
                }
            });
        });
    }
};
</script>

<style lang="less" scoped>
#IDCertify {
	margin: 20px 200px 0 0;
}
.authenticeface {
	padding: 24px 70px;
	position: relative;
	.authenticeface-operate {
		font-size: 16px;
		color: #000;
		letter-spacing: 0;
		line-height: 36px;
		font-weight: 800;
		margin-bottom: 10px;
	}
	.authenticeface-info {
		line-height: 40px;
		color: #282c33;
		font-size: 14px;
	}
	.agree {
		margin-top: 30px;
		.rule {
			color: #0052cc;
		}
	}
	.authenticeface-qrcode {
		height: 150px;
		overflow: hidden;
	}
	#IDCertifyQrcode {
		float: left;
	}
	.authenticeface-notify {
		float: left;
		margin-left: 60px;
		margin-top: 9px;
		.authenticefacescan {
			width: 100px;
		}
	}
}
</style>